import React, { useState } from "react";
import EmployeesAddForm from "./EmployeesAddForm";
import EmployeesRequests from "./EmployeesRequests";
import EmployeesList from "./EmployeesList";

const ADD = "add";
const REQ = "requests";
const LIST = "list";

const TABS = [
  { key: ADD, label: "Add Employee", icon: "bi-person-plus" },
  { key: REQ, label: "Requests", icon: "bi-inbox" },
  { key: LIST, label: "Employee List", icon: "bi-people" },
];

export default function AdminEmployees() {
  const [active, setActive] = useState(ADD);

  return (
    <section className="py-1">
      <div className="container">
        {/* Header + Tabs */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="mb-0">Employees</h3>
          <div className="btn-group">
            {TABS.map((t) => (
              <button
                key={t.key}
                className={`btn btn-sm ${
                  active === t.key ? "btn-primary" : "btn-outline-primary"
                } d-flex align-items-center gap-2`}
                onClick={() => setActive(t.key)}
              >
                <i className={`bi ${t.icon}`} aria-hidden="true" />
                <span>{t.label}</span>
              </button>
            ))}
          </div>
        </div>
        <hr />

        {active === ADD && <EmployeesAddForm />}
        {active === REQ && <EmployeesRequests />}
        {active === LIST && <EmployeesList />}
      </div>
    </section>
  );
}
